import { Branded }		from "ts-base/branded";
import { Strings }		from "ts-base/strings";
import { Equal }		from "ts-base/equal";

/** RFC 6265 cookie value */
export type CookieValue	= Branded<string, "CookieValue">;

export namespace CookieValue {
	export const name		= "CookieValue";

	export const brand		= Branded.brand<CookieValue>;
	export const is			= (it:string):it is CookieValue	=> /^[a-zA-Z0-9!#$%&'()*+./:<=>?@[\]^_`{|}~-]*$/.test(it);

	export const fromString	= (it:string):CookieValue|null	=> is(it) ? brand(it) : null;
	export const toString	= (it:CookieValue):string		=> it;

	export const equal:Equal<CookieValue>	= Strings.equal;
}
